import React from 'react';

import classNames from 'classnames';

import ChevronRightIcon from 'Assets/icons/chevron-right.svg';

const INDENT = ['tw-ps-2.5', 'tw-ps-8', 'tw-ps-14', 'tw-ps-20'];
const WEIGHT = ['tw-font-medium tw-text-charcoal', 'tw-font-normal tw-text-charcoal', 'tw-font-light tw-text-charcoal-75', 'tw-font-light tw-text-charcoal-75'];

/** The indented Line cell: chevron toggle for departments, cost centres and projects, then the name. */
export default function LineCell({ row, open, onToggle }) {
    return (
        <td className="tw-border-b tw-border-grey tw-p-0 tw-text-start">
            <div className={classNames('tw-flex tw-items-center tw-gap-x-1.5 tw-py-2 tw-pe-2.5', INDENT[row.depth], WEIGHT[row.depth])}>
                {row.hasChildren ? (
                    <button
                        type="button"
                        onClick={() => onToggle(row.key)}
                        aria-expanded={open}
                        aria-label={open ? $t('Collapse {{name}}', { name: row.name }) : $t('Expand {{name}}', { name: row.name })}
                        className="tw-flex tw-h-5 tw-w-5 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-text-charcoal-50 hover:tw-bg-charcoal-15 hover:tw-text-charcoal"
                    >
                        <ChevronRightIcon
                            className={classNames('tw-h-3 tw-w-3 tw-transition-transform rtl:tw-rotate-180', { '!tw-rotate-90': open })}
                            aria-hidden="true"
                        />
                    </button>
                ) : (
                    <span className="tw-w-5 tw-flex-shrink-0" />
                )}
                {/* Capped so a long name truncates instead of widening the table past the page. */}
                <span className="tw-max-w-[18rem] tw-truncate" title={row.name}>
                    {row.name}
                </span>
            </div>
        </td>
    );
}
